import { VariantProps, cva } from "class-variance-authority";
import { twMerge } from "tailwind-merge";
import { useTranslation } from "react-i18next";
import { Container } from "../Container";
import { Logo } from "../logo/logo";

export interface VenueLogoListProps
    extends VariantProps<typeof VenueLogoListStyles> {
    title?: string;
    includeBeat?: boolean;
    className?: string;
}

export const VenueLogoListStyles = cva(
    "flex flex-wrap xl:flex-nowrap justify-around gap-x-1 gap-y-6",
);

const VENUE_IDS = [
    "afas-dome",
    "lotto-arena",
    "forest-national",
    "trixxo-arena",
    "stadsschouwburg-antwerp",
    "capitole-ghent",
    "trixxo-theater",
    "beat-tickets",
];

export type VenueId = (typeof VENUE_IDS)[number];

const venueConfig = (id: VenueId) => ({
    id,
    position: VENUE_IDS.indexOf(id),
    url: import.meta.env[`VITE_${id.replaceAll("-", "_").toUpperCase()}_URL`],
});

export const VenueLogoList = ({
    className,
    title,
}: VenueLogoListProps): JSX.Element => {
    const { i18n } = useTranslation();

    return (
        <Container className="mb-8 mt-24">
            <div className="mb-4 text-center">
                <span>{title}</span>
            </div>
            <div className={twMerge(VenueLogoListStyles({ className }))}>
                {VENUE_IDS?.map((id) => {
                    return (
                        <div
                            key={id}
                            className="block w-48 pl-4 text-left lg:ml-4 lg:w-auto lg:pl-0"
                        >
                            <Logo
                                className="h-11 text-left lg:w-auto"
                                href={`${venueConfig(id).url}${
                                    i18n.language || "nl"
                                }`}
                                isInternalLink={false}
                                venueId={venueConfig(id).id}
                            />
                        </div>
                    );
                })}
            </div>
        </Container>
    );
};
